require('./style.less');

var Marionette = require('marionette'),
    _ = require('underscore');


/**
 * Maybe we change this to CHOSEN ....
 */

module.exports = Marionette.ItemView.extend({

    className: 'fr-note-type-select-wr',
    template: require('./template.hbs'),

    initialize: function( options ) {

        this.channel = options.channel;
        this.noteTypeGroup = options.noteTypeGroup; // ( value we use to set is from the group; this can be passed in null ) -- give it the note model instead?
        this.onChange = options.onChange;
        this.renderDisabled = options.renderDisabled;

    },

    ui: {
        'selectBox': '.fr-note-type-select'
    },

    events: {
        'change @ui.selectBox':  'onSelectValueChange'
    },

    serializeData: function() {

        var creatableNotesHelper =
            this.channel.request('creatableNoteTypesHelper');

        var noteConstructorsToPrint = creatableNotesHelper.getPrintedNoteTypesForFindAndRedact();
        var noteTypesToDisable = creatableNotesHelper.getDisallowedFindAndRedactNoteTypes();

        var noteTypeCxt = _.map(  noteConstructorsToPrint, function( note, noteType ) {

            return {
                noteType: noteType,
                displayName: note.prototype.desc,
                disable: noteTypesToDisable.indexOf( noteType ) > -1
            };

        });

        noteTypeCxt =_.sortBy( noteTypeCxt, function( typeCxt ) {
            return typeCxt.displayName;
        } );

        return {
            noteTypes: noteTypeCxt,
            disableSelectBox: this.renderDisabled || creatableNotesHelper.allFindAndRedactNoteTypesDisabled() // ( could just not render this if there are none, but this is fine )
        };

    },

    onRender: function() {

        this.ui.selectBox.val( this.noteTypeGroup );

    },

    onSelectValueChange: function( e ) {

        this.onChange( $(e.target).val() );

    }





});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/noteTypeSelect/view.js
 ** module id = 595
 ** module chunks = 0
 **/